import { TableRow } from '@shared/UI';
import { ISettingsTransactionsDto } from '@shared/api';

interface Options {
    onTransactionViewClick: (transaction: ISettingsTransactionsDto) => void;
}

export function getTransactionsTableRows(options: Options): TableRow<ISettingsTransactionsDto> {
    const { onTransactionViewClick } = options;
    return { onClick: (row) => () => onTransactionViewClick(row) };
}
